import styled from "@emotion/styled";

import { Button } from "../../../../../components/Form";
import { EstimatedQuoteStatus } from "../../../../../util/enums";

interface StyledProps {
  type: string;
}

export const Wrapper = styled("div")(() => ({
  padding: "12px 16px",
  height: "calc(100vh - 168px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column" as const,
}));

export const Icon = styled("span")(({ type }: StyledProps) => ({
  backgroundColor: type === EstimatedQuoteStatus.DECLINED ? "#FEF3F2" : "#EFF8FF",
  width: 72,
  height: 72,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 32,
  "& svg": {
    width: 35,
    height: 35,
    color: type === EstimatedQuoteStatus.DECLINED ? "#F04438" : "#308CDB",
  },
}));

export const Title = styled("h3")(({ type }: StyledProps) => ({
  color: type === EstimatedQuoteStatus.DECLINED ? "#F04438" : "#308CDB",
  font: "700 24px/33px Manrope",
  marginBottom: 20,
}));

export const Text = styled("span")(() => ({
  color: "#465869",
  font: "300 20px/28px Manrope",
  "&.mt80": {
    marginTop: 80,
  },
  "&.mt20": {
    marginTop: 20,
  },
}));

export const Content = styled("div")(() => ({
  width: 400,
  textAlign: "center" as const,
  display: "flex",
  flexDirection: "column" as const,
  "@media screen and (max-width: 435px)": {
    width: 340,
  },
}));
